import React from "react";

export default function StripButton({
  children,
  selected = false,
  onClick = () => {},
  className = "",
  label,
}) {
  return (
    <div
      role="button"
      tabIndex="0"
      className={`p-4 text-center group border border-gray-400 ${
        selected
          ? "bg-primary text-white"
          : "hover:bg-secondary-light cursor-pointer text-primary"
      } ${className}`}
      onClick={onClick}
      onKeyDown={onClick}
      aria-label={label}
    >
      {children}
    </div>
  );
}
